import { post } from 'utils/api';
import Config from 'utils/getEnvConfig';

const {
  LAMBDA: {
    ASSESSMENT_TRENDS_SCORINGS: { URL, API_KEY },
  },
} = Config;

const fetchTrends = async (_, params) => {
  const { answers, slug } = params;

  const response = await post(
    URL,
    { answers: answers.map(item => item.answers), slug },
    {
      headers: { 'x-api-key': API_KEY },
    },
  );

  return response.data;
};

export default fetchTrends;
